import { InitialState } from './types';

export default ({ currentUser }: InitialState) => ({
  alerts: currentUser?.permissions.includes('alerts'),
  devices: currentUser?.permissions.includes('devices'),
  labels: currentUser?.permissions.includes('labels'),
  labelTemplates: currentUser?.permissions.includes('label_templates'),
  manageLabels: currentUser?.permissions.includes('manage_labels'),
  manageLabelTemplates: currentUser?.permissions.includes('manage_label_templates'),
  reports: currentUser?.permissions.includes('reports'),
  samples: currentUser?.permissions.includes('samples'),
  settings: currentUser?.permissions.includes('settings'),
  thresholds: currentUser?.permissions.includes('thresholds'),
  users: currentUser?.permissions.includes('users'),
});
